import { A_Styled, Div_Styled } from './HomePage'
import { Helmet } from 'react-helmet'
import { theme } from './theme'
import React from 'react'
import styled from '@emotion/styled'

export const CvPage = () => {
  return (
    <Div_Styled>
      <Helmet>
        <title>Eva Janouskova - CV</title>
        <meta name='description' content='CV of Eva Janoušková, Frontend Developer' />
      </Helmet>

      <Container_div>
        <h1>Eva Janoušková</h1>
        <P_styled>
          Křepice (Břeclav district), CZ
          <br />
          +420 728 333 480
          <br />
          <A_Styled href='mailto:e.janouskova123@gmail.com'>e.janouskova123@gmail.com</A_Styled>
        </P_styled>
        <H4_styled>Professional Skills</H4_styled>
        <Ul_styled>
          <li>HTML5, CSS3</li>
          <li>React.js, JavaScript (ES6+, Node.js, TypeScript), Vue.js</li>
          <li>Shopify (Liquid, Theme Development)</li>
          <li>Selenium (E2E testing)</li>
          <li>Git, Jira</li>
        </Ul_styled>
        <H4_styled>Work Experience</H4_styled>
        <P_styled>ARRIVA TRANSPORT ČESKÁ REPUBLIKA a.s. – Frontend Developer</P_styled>
        <Ul_styled>
          <li>10/2024 – now</li>
          <li>
            Developed and maintained a train information system and an e-commerce platform, ensuring
            high performance, seamless functionality, and optimal user experience
          </li>
        </Ul_styled>
        <P_styled>OKAY Holding a.s. – Frontend Developer</P_styled>
        <Ul_styled>
          <li>1/2023 – 9/2024</li>
          <li>
            Developed and maintained an e-commerce platform, implemented end-to-end (E2E) testing,
            and leveraged Google Tag Manager (GTM) and Google Analytics (GA) for data tracking and
            performance optimization
          </li>
        </Ul_styled>
        <P_styled>CBL s.r.o. – NOC operator</P_styled>
        <Ul_styled>
          <li>9/2016 – 9/2017</li>
          <li>
            Monitored network performance and troubleshot technical issues to ensure system
            stability
          </li>
        </Ul_styled>
        <H4_styled>Courses</H4_styled>
        <P_styled>Smartbrains – ITAbsolvent</P_styled>
        <Ul_styled>
          <li>07/2022 – 09/2022</li>
          <li>Frontend development training focused on React and TypeScript</li>
        </Ul_styled>
        <P_styled>Czechitas – JavaScript</P_styled>
        <Ul_styled>
          <li>02/2022 – 05/2022</li>
          <li>Frontend development with a focus on JavaScript, including HTML and CSS</li>
        </Ul_styled>
        <P_styled>University of Ostrava – Basics of informatics</P_styled>
        <Ul_styled>
          <li>02/2022 – 05/2022</li>
          <li>
            Covered MS Office applications, informatics, presentation and communication
            technologies, and an introduction to web development
          </li>
        </Ul_styled>
        <H4_styled>Language Skills</H4_styled>
        <Ul_styled>
          <li>Czech – Native proficiency</li>
          <li>English – C1 Advanced proficiency</li>
        </Ul_styled>
      </Container_div>
    </Div_Styled>
  )
}

const Container_div = styled.div`
  padding: 10px;
  box-sizing: border-box;
  margin: auto;
  max-width: 650px;
  font-size: inherit;
  font-family: inherit;
  text-align: left;

  @media screen and ${theme.mediaSMax} {
    width: 95%;
  }
`
const Ul_styled = styled.ul`
  list-style-type: circle;
  margin: 0px;
`
const H4_styled = styled.h4`
  margin: 25px 0px 10px 0px;
`
const P_styled = styled.p`
  margin: 10px 0px 5px 0px;
`
